import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import DefaultButton from "../../styles/materialButtonStyle";
import Notification from "../../elements/notification/Notification";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { useTranslation } from "react-i18next";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import MaterialDialog from "../../styles/materialDialog";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ProjectsForm = ({ fetchProjects }) => {
  const { t } = useTranslation("projectsPage");
  const [open, setOpen] = useState(false);

  const [projectName, setProjectName] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const createInvoice = () => {
    let trimmedProjectName = projectName.trim();

    setProjectName(trimmedProjectName);

    if (!trimmedProjectName || trimmedProjectName.length === 0) {
      setNotification({ ...notification, visible: true, type: "error", message: t("create.errors.projectNameMessage") });
      return;
    }

    let data = {
      name: trimmedProjectName
    };

    setLoading(true);

    axios.post("/api/projects", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === 201) {
        handleClose();
        fetchProjects();
        setNotification({ ...notification, visible: true, type: "success", message: t("create.success") });
      }
    }).catch(error => {
      console.log(error.response.data);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification, setError);
    }).finally(() => setLoading(false));
  };

  const handleClose = () => {
    setOpen(false);
    setProjectName(null);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="project-head__create">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("create.form.create")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("create.form.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              <TextField
                id="name"
                label={t("create.form.name")}
                error={error.name}
                helperText={error.name}
                value={projectName}
                onChange={(data) => {setProjectName(data.target.value); setError({ ...error, name: null})}}
                required
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
              >
                {t("create.form.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={createInvoice}
                color="success"
                disabled={loading}
              >
                {t("create.form.create")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </div>
    </>
  );
};

export default ProjectsForm;